import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "content"
};
var _hoisted_2 = {
  style: {
    "border": "1px solid #c9c9c9"
  }
};
export default {
  __name: 'AdminPrint',
  setup: function setup(__props) {
    var tableData = [{
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles'
    }, {
      date: '2016-05-02',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles'
    }, {
      date: '2016-05-04',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles'
    }, {
      date: '2016-05-01',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles'
    }];
    return function (_ctx, _cache) {
      var _component_P = _resolveComponent("P");
      var _component_el_table_column = _resolveComponent("el-table-column");
      var _component_el_table = _resolveComponent("el-table");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_P, {
        "class": "breadcrumb"
      }, {
        "default": _withCtx(function () {
          return _cache[0] || (_cache[0] = [_createElementVNode("span", null, "首页", -1), _createElementVNode("span", {
            "class": "margin-lr-10p"
          }, ">", -1), _createElementVNode("span", null, "个人中心", -1), _createElementVNode("span", {
            "class": "margin-lr-10p"
          }, ">>", -1), _createElementVNode("span", null, "打印准考证", -1)]);
        }),
        _: 1
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createStaticVNode("<div class=\"msg\" data-v-07b12750><p data-v-07b12750>2024年5月18日AFM全国统一考试</p><ul data-v-07b12750><li data-v-07b12750><b data-v-07b12750>准考证号：</b> xxxxxxxxxx</li><li data-v-07b12750><b data-v-07b12750>姓名：</b> 詹</li><li data-v-07b12750><b data-v-07b12750>身份证号：</b>xxxxxxxx</li><li data-v-07b12750><b data-v-07b12750>考点：</b>线上</li><li data-v-07b12750><b data-v-07b12750>座位号：</b>20</li><li data-v-07b12750><b data-v-07b12750>地址：</b>xxxxxxxxxxxxxxxxxxx</li></ul></div>", 1)), _withDirectives(_createVNode(_component_el_table, {
        data: tableData,
        border: "",
        style: {
          "width": "100%"
        }
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_el_table_column, {
            prop: "date",
            label: "考试科目",
            center: ""
          }), _createVNode(_component_el_table_column, {
            prop: "name",
            label: "考试日期"
          }), _createVNode(_component_el_table_column, {
            prop: "address",
            label: "考试时间"
          })];
        }),
        _: 1
      }, 512), [[_vShow, !_ctx.isPay]]), _cache[2] || (_cache[2] = _createElementVNode("p", {
        "class": "title"
      }, "考场规章", -1)), _cache[3] || (_cache[3] = _createElementVNode("ul", {
        "class": "guiZhang"
      }, [_createElementVNode("li", null, " 1.凭本人准者证和有效身份证件进入指定的考场，无身份证的应考人不得入场，应考人的姓名和身份证信息必须光全匹配。并将身份证体放在考赢右上角，以备监考人随时核查。 "), _createElementVNode("li", null, "2.迟到30分钟以上的应专人不得入场专试，专试开始后30分钟内不得交学出场，"), _createElementVNode("li", null, "3、应书人只准济带丽色钢笔或水笔以及维定的财务计算器进入考场，只能使用专试的员会指定的证"), _createElementVNode("li", null, "4、考试开始前不得扫网试程。"), _createElementVNode("li", null, "5.将手机、都能手表或任同电子设备放在监考人指示的位置。"), _createElementVNode("li", null, "6.应书人须按要求，在首县卡指定位置填涂首高，写在其它任同始方均无效。")], -1))])])], 64);
    };
  }
};